import { defineRecipe } from '@chakra-ui/react';

export const headingRecipe = defineRecipe({
  className: 'heading',
  base: {
    color: 'white',
  },
});
